import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Button } from 'rebass/styled-components'
import { IProperties } from '../../builder/types';
import { IFormMeta } from '../../builder/Builder';
import styled from 'styled-components';
import RichTextEditor from 'react-rte';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { parseStringify } from '../../../../utils/StringUtils';
import { FillingInput } from './controls/FillingInput';
import { FillingLineBreak } from './controls/FillingLineBreak';
import { FillingCheckBoxes } from './controls/FillingCheckBoxes';
import { FillingRangeCtrl } from './controls/FillingRangeCtrl';
import { FillingTextArea } from './controls/FillingTextArea';
import { FillingDropdown } from './controls/FillingDropdown';
import { FillingLabel } from './controls/FillingLabel';
import { FillingRating } from './controls/FillingRating';
import { FillingParagraph } from './controls/FillingParagraph';
import { FillingHeading } from './controls/FillingHeading';
import TextEditorEmbed from './TextEditorEmbed';

const EditorWrapper = styled(Flex)`
overflow-y:auto;
width: 100%;
 max-width: 836px;
padding-right: 24px;
max-height: calc(100vh - 44px);
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`
interface IFillingFormInnerProps {
  template: IProperties[],
  meta: IFormMeta,
  save: (content: string) => void
  saving?: boolean
  onCancelRequested:()=>void

}


const getInitialData = (tree: Array<IProperties>) => {
  console.log({ tree });
  const data: any = {};

  for (let index = 0; index < tree.length; index++) {
    const element = tree[index];
    if (element.key === 'LineBreak' || element.key === 'Header' || element.key === 'Label' || element.key === 'Paragraph') continue;
    if (element.key === 'TextInput' || element.key === 'Email' || element.key === 'Date') {
      data[element.id] = '';
      continue;
    }
    if (element.key === 'Range') {
      data[element.id] = ((element.params || {}).ctrlProps || {}).min || 0;
      continue;
    }
    if (element.key === 'Dropdown') {
      data[element.id] = '';
      continue;
    }
    if (element.key === 'Rating') {
      data[element.id] = 0;
      continue;
    }
    if (element.key === 'NumberInput') {
      data[element.id] = null;
      continue;
    }
    if (element.key === 'TextArea') {
      data[element.id] = RichTextEditor.createEmptyValue(); //.createValueFromString(`<p>aaa <strong>aaa</strong> aaa</p>`,'html')
      continue;
    }

    if (element.key === 'Checkboxes') {
      for (let i2 = 0; i2 < (((element.params || {}).ctrlProps || {}).options || []).length; i2++) {
        const e2 = (((element.params || {}).ctrlProps || {}).options || [])[i2];
        data[`${element.id}__${e2.value}`] = e2.isChecked || false;
      }
    }
  }

  console.log({ data });
  return data;
};
const getSchema = (tree: Array<IProperties>) => {
  let schema: any = {};

  for (let index = 0; index < tree.length; index++) {
    const element = tree[index];
    console.log('is required', ((element.params || {}).ctrlProps || {}).required)
    if (((element.params || {}).ctrlProps || {}).required) {
      if (element.key === 'Email') {
        schema[element.id] = Yup.string()
          .email('Invalid email')
          .required('Required');
      } else if (element.key === 'Date') {
        schema[element.id] = Yup.date().required('Required');
      } else if (element.key === 'NumberInput') {
        schema[element.id] =  Yup.string()
        .trim()
        .min(1, 'Response cannot be empty')
        .required('Required');
      } else {
        schema[element.id] = Yup.string()
          .trim()
          .min(2, 'Response must be greater than 1 character')
          .required('Required');
      }
    }
  }
  return Yup.object().shape({ ...schema });
};

export const FillingFormInner: React.FC<IFillingFormInnerProps> = ({
  template,
  meta,
  saving,
  save,
  onCancelRequested
}) => {
  const [data, setData] = useState(getInitialData(template));
  const [schema] = useState(getSchema(template));
  const [outputResult, setOutputResult] = useState<string | null>(null);
  console.log({ outputResult })
  return (
    <EditorWrapper flexDirection={'column'} id='editorWrap'>
      <Formik
        initialValues={{ ...getInitialData(template) }}
        validationSchema={getSchema(template)}
        isInitialValid={() => {
          try {
            const aa = schema.isValidSync({ ...getInitialData(template) });

            // const bb = await aa.isValid()
            return aa
          } catch (err) {
            return false;
          }
        }}
        onSubmit={(values, actions) => {
          console.log({ values });
          let res: any = {};
          const resTree = parseStringify(template);

          for (const key in values) {
            if (key.indexOf('Checkboxes_') > -1) {
              const sp = key.split('__');
              if (!!sp && sp.length > 1) {
                const a2 = resTree.findIndex((x: any) => x.id === sp[0]);
                if (!resTree[a2].values) {
                  resTree[a2].values = [];
                }
                resTree[a2].values.push({
                  [sp[1]]: (values as any)[key],
                });
              }
              continue;
            }
            const a = resTree.findIndex((x: any) => x.id === key);

            if (key.indexOf('TextArea_') < 0) {
              res[key] = (values as any)[key];
              resTree[a].value = (values as any)[key];
            } else {
              const s = (values as any)[key].toString('html');
              res[key] = s;
              resTree[a].value = s;
            }
          }
          console.log({ resTree });
          setOutputResult(JSON.stringify(resTree, null, 4));
          save(JSON.stringify(resTree))
        }}
      >
        {({ touched, errors, isValid, values, submitForm, setFieldValue, setFieldTouched }) => {
          // console.log({ errors, touched, values });
          return (
            <Form>
              <>
              <Flex width={'100%'} justifyContent={'space-between'}>
                <Button variant={'primary'} onClick={submitForm} disabled={!isValid || saving}>Save</Button>
                <Button variant={'pink'} onClick={onCancelRequested} type="button" >Cancel</Button>
                </Flex>
                {template.map((treeItem) => (
                  <Flex
                    width={'100%'}
                    style={{
                      padding: treeItem.key === 'Header' ? '12px 0 20px 0' : treeItem.key === 'Label' ? '18px 0 12px' : treeItem.key === 'LineBreak' ? '6px 0' : '6px 0 12px 32px',
                    }}
                  >
                    {treeItem.key === 'TextInput' || treeItem.key === 'NumberInput' || treeItem.key === 'Email' || treeItem.key === 'Date' ? (
                      <FillingInput properties={treeItem} name={treeItem.id} touched={touched} errors={errors} />
                    ) : null}
                    {treeItem.key === 'LineBreak' ? <FillingLineBreak /> : null}
                    {treeItem.key === 'Checkboxes' ? <FillingCheckBoxes properties={treeItem} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} /> : null}
                    {treeItem.key === 'Header' ? <FillingHeading properties={treeItem} /> : null}
                    {treeItem.key === 'Range' ? <FillingRangeCtrl name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                    {treeItem.key === 'TextArea' ? <TextEditorEmbed name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} touched={touched} errors={errors} /> : null}
                    {treeItem.key === 'Dropdown' ? (
                      <FillingDropdown
                        name={treeItem.id}
                        values={values}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        properties={treeItem}
                        touched={touched}
                        errors={errors}
                      />
                    ) : null}
                    {treeItem.key === 'Label' ? <FillingLabel properties={treeItem} /> : null}
                    {treeItem.key === 'Rating' ? <FillingRating name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                    {treeItem.key === 'Paragraph' ? <FillingParagraph properties={treeItem} /> : null}
                  </Flex>
                ))}
              </>
            </Form>
          );
        }}
      </Formik>
    </EditorWrapper>);
}